import {createReducer, on} from '@ngrx/store';
import {setProductFilter, clearProductFilter} from '../actions/product-filter.actions';

// BCH-533622 - Store selected products per project
export interface ProductFilterState {
  selectedProductsByProject: { [projectId: string]: number[] }; // BCH-533622 - changed from string[] to number[]
}

export const initialState: ProductFilterState = {
  selectedProductsByProject: {},
};

export const reducer = createReducer(
  initialState,
  on(setProductFilter, (state, {projectId, selectedProductIds}) => ({
    ...state,
    selectedProductsByProject: {
      ...state.selectedProductsByProject,
      [projectId]: selectedProductIds, // BCH-533622 - changed from selectedProducts to selectedProductIds
    },
  })),
  on(clearProductFilter, (state, {projectId}) => {
    const {[projectId]: _, ...rest} = state.selectedProductsByProject;
    return {
      ...state,
      selectedProductsByProject: rest,
    };
  })
);
